import { render, staticRenderFns } from "./RelLog.vue?vue&type=template&id=2cfe64f8&scoped=true"
import script from "./RelLog.vue?vue&type=script&lang=js"
export * from "./RelLog.vue?vue&type=script&lang=js"
import style0 from "./RelLog.vue?vue&type=style&index=0&id=2cfe64f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe64f8",
  null
  
)

export default component.exports